import type { OrderStatus } from "@tilt/pos-sdk";

/** Map an order status enum value to its i18n key. Lives here (not in
 *  the StatusBadge component) so a fast-refresh-only-components lint
 *  rule stays happy. Caller passes the result through ``t()``. */
export function orderStatusLabelKey(status: OrderStatus): string {
  switch (status) {
    case "open":
      return "status.open";
    case "partially_paid":
      return "status.partiallyPaid";
    case "paid":
      return "status.paid";
    case "voided":
      return "status.voided";
    case "partially_refunded":
      return "status.partiallyRefunded";
    case "refunded":
      return "status.refunded";
  }
}
